const API_URL = "https://azteq-server.onrender.com/api";

// Create a new thread
const createThread = async () => {
  try {
    const response = await fetch(`${API_URL}/threads`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      console.log("response", response);
      throw new Error("Failed to create thread");
    }

    const data = await response.json();
    return data.threadId;
  } catch (error) {
    console.error("Error creating thread:", error);
    throw error;
  }
};

// Send a message in a specific thread
const sendMessage = async (threadId, message) => {
  console.log("Sending message:", message);
  console.log("Thread ID:", threadId);
  try {
    const response = await fetch(`${API_URL}/chat`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        threadId: threadId,
        message: message,
      }),
    });

    if (!response.ok) {
      throw new Error("Failed to send message");
    }

    const data = await response.json();
    return data.response;
  } catch (error) {
    console.error("Error sending message:", error);
    throw error;
  }
};

export { createThread, sendMessage };
